import { useEffect, useState } from "react";
import { getActiveBook, Manifest, setLedgerPageBook } from "../api";
import Blotter from "./Blotter";
import Performance, { BOOK_LABEL, BOOKS } from "./Performance";
import PostMortems from "./PostMortems";

// What HAPPENED — led by the view that matters: the traceable win/loss record,
// then raw orders, then the nightly post-mortems.
const TABS = [
  ["performance", "Performance"],
  ["orders", "Orders"],
  ["postmortems", "Post-Mortems"],
] as const;

// Book selection lives HERE, one level up, shared by all three tabs — it used
// to be local to the Performance tab only, so switching it did nothing for
// Orders/Post-Mortems, which just silently followed the sidebar's book
// instead. Looked like "the filter doesn't deal with" paper trades cluttering
// the page (found 2026-08-04) when really there were two different,
// disconnected book selectors on what reads as one page.
export default function Ledger({ manifest }: { manifest: Manifest }) {
  const [tab, setTab] = useState<string>("performance");
  // Opens on the sidebar's active book, not "all" — the frame chip was
  // claiming a book while the page silently defaulted to a paper+live blend
  // (Kaizen D4/F5). "All" stays one click away, and whatever is selected is
  // published so the chip reads the page's own truth.
  const [book, setBook] = useState<string>(getActiveBook());
  useEffect(() => { setLedgerPageBook(book); }, [book]);
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-1 flex-wrap">
          <h1 className="text-lg font-bold mr-2">Performance</h1>
          {TABS.map(([id, label]) => (
            <button key={id} onClick={() => setTab(id)}
                    className={`badge ${tab === id ? "bg-accent/20 text-accent" : "bg-slate-800 text-slate-400"}`}>
              {label}
            </button>
          ))}
        </div>
        <div className="flex gap-1">
          {BOOKS.map((b) => (
            <button key={b} onClick={() => setBook(b)}
              className={`badge ${book === b ? (b.startsWith("live") ? "bg-down/20 text-down" : "bg-accent/20 text-accent") : "bg-slate-800 text-slate-400"}`}>
              {BOOK_LABEL[b]}
            </button>
          ))}
        </div>
      </div>
      {tab === "orders" && <Blotter manifest={manifest} book={book} />}
      {tab === "performance" && <Performance manifest={manifest} book={book} />}
      {tab === "postmortems" && <PostMortems manifest={manifest} book={book} />}
    </div>
  );
}
